import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import projectClonesService from './../../services/claim_project_reports/project_clones.service.js';
import CloneProjectStatus from './CloneProjectStatus';
const shouldWaitForResult = status => ['not_started', 'pending'].includes(status);
const CloneProject = _ref => {
  var _lastImportStatus$sta;
  let {
    reportId,
    setLoading,
    loading,
    fetchReports
  } = _ref;
  const {
    createProjectCloneStatus,
    importStatus: lastImportStatus,
    interval: fetchImportStatusInterval
  } = projectClonesService.useCrud(reportId, setLoading, fetchReports);
  const {
    t
  } = useTranslation();
  if (shouldWaitForResult(lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.status) && !(fetchImportStatusInterval !== null && fetchImportStatusInterval !== void 0 && fetchImportStatusInterval.started)) {
    fetchImportStatusInterval.start();
    setLoading(true);
  } else if (!shouldWaitForResult(lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.status) && fetchImportStatusInterval !== null && fetchImportStatusInterval !== void 0 && fetchImportStatusInterval.started) {
    fetchImportStatusInterval.clear();
    setLoading(false);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: shouldWaitForResult(lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.status) || loading,
    onClick: () => createProjectCloneStatus()
  }, shouldWaitForResult(lastImportStatus === null || lastImportStatus === void 0 ? void 0 : lastImportStatus.status) || loading ? t('loading') : t('clone_project'))), !!(lastImportStatus !== null && lastImportStatus !== void 0 && (_lastImportStatus$sta = lastImportStatus.status) !== null && _lastImportStatus$sta !== void 0 && _lastImportStatus$sta.length) && /*#__PURE__*/React.createElement(CloneProjectStatus, {
    importStatus: lastImportStatus
  }));
};
export default CloneProject;